import { api_recommended_projects_path } from '@routes';

import request from './request';

export interface RecommendedProject {
  description: string;
  id: number;
  publishedAt: string;
  theme: string | null;
  title: string;
  url: string;
}

export interface RecommendedProjectsResponse {
  projects: RecommendedProject[];
}

export async function getRecommendedProjects(
  mostReadTopic?: string
): Promise<RecommendedProjectsResponse> {
  const params = mostReadTopic ? { most_read_topic: mostReadTopic } : {};
  return request('get', api_recommended_projects_path(), params);
}
